import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import {Router} from '@angular/router';
import { ActivatedRoute } from "@angular/router";
import { DataserviceService } from "../../dataservice.service";
import Swal from 'sweetalert2';





@Component({
  selector: 'app-bank-detail',
  templateUrl: './bank-detail.component.html',
  styleUrls: ['./bank-detail.component.css']
})
export class BankDetailComponent implements OnInit {
height:Number;
bank_id:Object;
showBankDetail:any={};
editBankDetail:Number;





  constructor(private router:Router,private route: ActivatedRoute,private dataservice:DataserviceService) { 
    this.route.queryParams.subscribe(params => {this.bank_id = params.id});
    console.log(this.bank_id);
  }

  ngOnInit() {
    this.editBankDetail=0;
    var nnn = $('.header-section').innerHeight();
    var nnn1= $('.breadcrumb.breadcrumb-top').innerHeight();
    var nnn2 = $('.clearfix').innerHeight();
    this.height =innerHeight - nnn - nnn1 - nnn2 + 17;

 
    this.dataservice.bankDetail(this.bank_id).subscribe(
      data=>{
        console.log(data);
        
this.showBankDetail=data;
      }
    )





  }




  editBank(){
console.log(this.showBankDetail);
this.dataservice.addBank1(this.showBankDetail).subscribe(
  data=>{
    Swal("Update Saved");
    this.editBankDetail=0;
    console.log(data);
    
  }
)

  }


  clickEditbtn(){
this.editBankDetail=1;
  }


}
